module.exports = __webpack_public_path__ + "assets/icons/ic_dt_data_connector.svg";